export default __webpack_public_path__ + "static/O0039-384ee5d22768b5cdb2cead9ec919a854.png";